import { Fragment, type FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { ShareTabFrame } from '@xing-com/crate-social-share';
import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';
import { IconWarning } from '@xing-com/icons';
import { Hero } from '@xing-com/typography';

import { useGetUrn } from '../../hooks/use-get-urn';
import { messages } from '../../messages';
import type { BackendTrackingMetaDataProps } from '../../types';
import * as Styled from './external-share-frame.styles';
export type ShareFrameSharedProps = {
  url: string;
  backendTrackingMetaData: BackendTrackingMetaDataProps;
};
export const ExternalShareFrame: FC<ShareFrameSharedProps> = ({
  url,
  backendTrackingMetaData,
}) => {
  const { loading, error, hasExternalLinkError, urn } = useGetUrn(url);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClick = () => {
    window.location.reload();
  };

  if (loading) {
    return (
      <Styled.Background>
        <DotLoadingIndicator />
      </Styled.Background>
    );
  }

  if (error) {
    <Styled.Background>
      <Styled.Container>
        <IconWarning height={64} width={64} />
        {hasExternalLinkError ? (
          <Hero>
            <FormattedMessage {...messages.shareExternalLinkError} />
          </Hero>
        ) : (
          <Fragment>
            <Hero>
              <FormattedMessage {...messages.shareFetchError} />
            </Hero>
            <Button loading={loading} onClick={handleClick}>
              <FormattedMessage {...messages.shareFetchErrorRetry} />
            </Button>
          </Fragment>
        )}
      </Styled.Container>
    </Styled.Background>;
  }

  return (
    <ShareTabFrame
      entryPoint="share_extension_social_share"
      interactionTargetUrn={urn}
      onCancel={() => window.close()}
      onSuccess={() => window.close()}
      openWithShareTo="FEED"
      propChannel="wbm/Share_Extension"
      url={url}
      verb="POST"
      backendTrackingMetaData={backendTrackingMetaData}
    />
  );
};
